import { MobileCallButton } from "@/components/MobileCallButton";
import OrderRequestButton from "@/components/order/OrderRequestButton";
import GetStartedButton from "@/components/consultation/GetStartedButton";
import ConsentBanner from "@/components/consent/ConsentBanner";

/**
 * Bottom-right stack for the site's floating actions.
 *
 * These used to position themselves individually with the same
 * `fixed bottom-6 right-6`, so any two that rendered together landed on top of
 * each other. They are laid out here instead: each button decides only whether
 * it renders, and the ones that do stack upward in a fixed order.
 *
 * Bottom of the stack is the easiest to reach, so the primary CTA sits there.
 *
 * Below md the stack spans the screen width so the assessment CTA can sit
 * centered along the bottom edge (the rest stay right-aligned above it). The
 * container itself is click-through — only the buttons take taps — so the
 * empty space beside them never blocks the page underneath.
 */
export default function FloatingActions() {
  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-40 flex flex-col items-end gap-3 md:inset-x-auto md:bottom-6 md:right-6 [&>*]:pointer-events-auto">
      <ConsentBanner />
      <MobileCallButton />
      <OrderRequestButton />
      <GetStartedButton />
    </div>
  );
}
